export default {
  "content": "<path d=\"M11.25 6.75h-4.5v4.5h-1.5v-4.5H.75v-1.5h4.5V.75h1.5v4.5h4.5v1.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "12",
    "fill": "none",
    "viewBox": "0 0 12 12"
  }
};